import React from 'react';
import {
  ItpRfqContextQuery_currentItpUser_account as LimitedAccount,
  ItpRfqContextQuery_currentItpUser as LimitedUser,
} from '../../../context/types/ItpRfqContextQuery';
import styles from './styles.scss';

type SubbieDetailsProps = {
  account?: LimitedAccount;
  user: LimitedUser;
};

const SubbieDetails: React.VFC<SubbieDetailsProps> = ({ account = null, user }) => (
  <div className={styles.subbieDetails}>
    <h4>Your Details</h4>
    {account && <div>{account.name}</div>}
    <div>{user.fullName}</div>
    <div>{user.email}</div>
  </div>
);

export default SubbieDetails;
